import { render } from "./PencilIcon.vue?vue&type=template&id=5cfb81a3&scoped=true"
import script from "./PencilIcon.vue?vue&type=script&lang=js"
export * from "./PencilIcon.vue?vue&type=script&lang=js"

import "./PencilIcon.vue?vue&type=style&index=0&id=5cfb81a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb81a3"]])

export default __exports__